import React, { Fragment, useEffect } from 'react';
import TablePage from '../../../../../components/pages/TablePage';
import { Button, message } from 'antd';
import { useHistory } from 'react-router-dom';
import { loadAirlines, loadAirports, loadCofigs, loadConsignee, loadShipper, loadNotify, loadHsCode } from '../../../../../redux';
import { useDispatch, useSelector } from 'react-redux';
import { EditOutlined, FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import moment from 'moment';
import numeral from 'numeral';
import { RiMailSendLine } from 'react-icons/ri';
import axios from 'axios';
import { RkspPrintButton } from './printIm';

export default () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { configCache } = useSelector(state => state.apps);

    const columns = [
        {
            name: "Action",
            id: 'action',
            width: "200px",
            selector: (row) => {
                return (
                    <Fragment>
                        <Button
                            shape='circle'
                            icon={<EditOutlined />}
                            type="link"
                            title='Edit Data'
                            onClick={() => {
                                history.push({ pathname: "/telex/rksp/form", state: { ...row } });
                            }}
                            style={{ color: 'blue' }}
                        />
                        <Button
                            shape='circle'
                            icon={<FileExcelOutlined />}
                            type="link"
                            title='Download'
                            onClick={() => {
                                exportDataToExcel(row, `${row?.header[0]?.call_sign || "-"} ${row?.header[0]?.tgl_tiba || "-"}`);
                            }}
                            style={{ color: 'green' }}
                        />
                        <RkspPrintButton data={row} configCache={configCache} />
                        <Button
                            shape='circle'
                            icon={<RiMailSendLine />}
                            type="link"
                            title='Send Data'
                            onClick={() => {
                                sendDataLocal(row, `${row?.header[0]?.call_sign || "-"} ${row?.header[0]?.tgl_tiba || "-"}`);
                            }}
                            style={{ color: 'orange' }}
                        />
                    </Fragment>
                );
            }
        },
        {
            selector: ({ header }) => header[0]?.nomor_aju,
            name: "NUMBER AJU",
            id: 'nomor_aju',
            width: "300px"
        },
        {
            selector: ({ header }) => header[0]?.kppbc,
            name: "KPPBC",
            id: 'kppbc'
        },
        {
            selector: ({ header }) => header[0]?.no_imo,
            name: "AIRLINE",
            id: 'no_imo'
        },
        {
            selector: ({ header }) => header[0]?.call_sign,
            name: "FLIGHT NUMBER",
            id: 'call_sign'
        },
        {
            selector: ({ header }) => header[0]?.tgl_tiba,
            name: "FLIGHT DATE",
            id: 'nomor_aju'
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY')) || '-',
            name: "CREATED DATE",
            id: 'createdAt'
        }
    ]

    const exportDataToExcel = (data, filename = 'data-export') => {
        const workbook = XLSX.utils.book_new();
        const buildSheetData = (dataArray, keyMap, heads) => {
            if (dataArray.length === 0) {
                const emptyRow = {};
                heads.forEach(header => {
                    emptyRow[header] = "";
                });
                return [emptyRow];
            }
            return dataArray.map(item => {
                const row = {};
                keyMap.forEach((key, i) => {
                    row[heads[i]] = item[key] !== undefined ? item[key] : "";
                });
                return row;
            });
        };

        const mapMasterKeys = [
            "id master",
            "nomor aju",
            "kd kelompok pos",
            "no master bl/awb",
            "tgl master bl/awb",
            "jml host bl/awb",
            "status detil",
            "respon"
        ]
        const mapDetilKeys = [
            "id_detil",
            "id_master",
            "nomor_aju",
            "kd_kelompok_pos",
            "no_pos",
            "no_sub_pos",
            "no_sub_sub_pos",
            "no_master_blawb",
            "tgl_master_blawb",
            "no_host_blawb",
            "tgl_host_blawb",
            "mother_vessel",
            "npwp_consignee",
            "nama_consignee",
            "almt_consignee",
            "neg_consignee",
            "npwp_shipper",
            "nama_shipper",
            "almt_shipper",
            "neg_shipper",
            "nama_notify",
            "almt_notify",
            "neg_notify",
            "pelabuhan_asal",
            "pelabuhan_transit",
            "pelabuhan_bongkar",
            "pelabuhan_akhir",
            "jumlah_kemasan",
            "jenis_kemasan",
            "merk_kemasan",
            "jumlah_kontainer",
            "bruto",
            "volume",
            "fl_partial",
            "total_kemasan",
            "total_kontainer",
            "status_detil",
            "fl_konsolidasi",
            "fl_pecah",
            "fl_perbaikan",
            "jenis_id_shipper",
            "jenis_id_consignee"
        ]
        const mapBarangKeys = [
            "id_barang",
            "id_detil",
            "seri_barang",
            "hs_code",
            "uraian_barang"
        ]
        const mapDokumenKeys = [
            "id_dokumen",
            "id_detil",
            "kode_dokumen",
            "nomor_dokumen",
            "tanggal_dokumen",
            "kode_kantor"
        ]
        const mapKontainerKeys = [
            "id_kontainer",
            "id_detil",
            "seri_kontainer",
            "nomor_kontainer",
            "ukuran_kontainer",
            "tipe_kontainer",
            "jenis_kontainer",
            "nomor_segel",
            "status_kontainer"
        ]
        const mapResponKeys = [
            "id respon",
            "nomor aju",
            "kode respon",
            "tanggal respon",
            "waktu respon",
            "nomor dokumen respon",
            "tanggal dokumen respon",
            "kode kantor",
            "byte stream pdf",
            "flag baca"
        ]
        const headsMaster = [
            "ID MASTER",
            "NOMOR AJU",
            "KD KELOMPOK POS",
            "NO MASTER BL/AWB",
            "TGL MASTER BL/AWB",
            "JML HOST BL/AWB",
            "STATUS DETIL",
            "RESPON"
        ];
        const headsDetil = [
            "ID DETIL",
            "ID MASTER",
            "NOMOR AJU",
            "KD KELOMPOK POS",
            "NO POS",
            "NO SUB POS",
            "NO SUB SUB POS",
            "NO MASTER BLAWB",
            "TGL MASTER BLAWB",
            "NO HOST BLAWB",
            "TGL HOST BLAWB",
            "MOTHER VESSEL",
            "NPWP CONSIGNEE",
            "NAMA CONSIGNEE",
            "ALMT CONSIGNEE",
            "NEG CONSIGNEE",
            "NPWP SHIPPER",
            "NAMA SHIPPER",
            "ALMT SHIPPER",
            "NEG SHIPPER",
            "NAMA NOTIFY",
            "ALMT NOTIFY",
            "NEG NOTIFY",
            "PELABUHAN ASAL",
            "PELABUHAN TRANSIT",
            "PELABUHAN BONGKAR",
            "PELABUHAN AKHIR",
            "JUMLAH KEMASAN",
            "JENIS KEMASAN",
            "MERK KEMASAN",
            "JUMLAH KONTAINER",
            "BRUTO",
            "VOLUME",
            "FL PARTIAL",
            "TOTAL KEMASAN",
            "TOTAL KONTAINER",
            "STATUS DETIL",
            "FL KONSOLIDASI",
            "FL PECAH",
            "FL PERBAIKAN",
            "JENIS ID SHIPPER",
            "JENIS ID CONSIGNEE"
        ];
        const headsBarang = [
            "ID BARANG",
            "ID DETIL",
            "SERI BARANG",
            "HS CODE",
            "URAIAN BARANG"
        ];
        const headsDokumen = [
            "ID DOKUMEN",
            "ID DETIL",
            "KODE DOKUMEN",
            "NOMOR DOKUMEN",
            "TANGGAL DOKUMEN",
            "KODE KANTOR"
        ];
        const headsKontainer = [
            "ID KONTAINER",
            "ID DETIL",
            "SERI KONTAINER",
            "NOMOR KONTAINER",
            "UKURAN KONTAINER",
            "TIPE KONTAINER",
            "JENIS KONTAINER",
            "NOMOR SEGEL",
            "STATUS KONTAINER"
        ];
        const headsRespon = [
            "ID RESPON",
            "NOMOR AJU",
            "KODE RESPON",
            "TANGGAL RESPON",
            "WAKTU RESPON",
            "NOMOR DOKUMEN RESPON",
            "TANGGAL DOKUMEN RESPON",
            "KODE KANTOR",
            "BYTE STREAM PDF",
            "FLAG BACA"
        ];
        const keyLabelMap = {
            "nomor_aju": "NOMOR AJU",
            "id_data": "ID DATA",
            "npwp": "NPWP",
            "jns_manifest": "JNS MANIFEST",
            "kd_jns_manifest": "KD JNS MANIFEST",
            "kppbc": "KPPBC",
            "no_bc_10": "NO BC 10",
            "tgl_bc_10": "TGL BC 10",
            "no_bc_11": "NO BC 11",
            "tgl_bc_11": "TGL BC 11",
            "nama_sarana_angkut": "NAMA SARANA ANGKUT",
            "kode_moda": "KODE MODA",
            "call_sign": "CALL SIGN",
            "no_imo": "NO IMO",
            "no_mms": 'NO_MMSI',
            "negara": "NEGARA",
            "no_voyage_arrival": "NO VOYAGE / ARRIVAL",
            "departure_flight": "DEPARTURE FLIGHT",
            "nahkoda": "NAHKODA",
            "handling_agent": "HANDLING AGENT",
            "pelabuhan_asal": "PELABUHAN ASAL",
            "pelabuhan_transit": "PELABUHAN TRANSIT",
            "pelabuhan_bongkar": "PELABUHAN BONGKAR",
            "pelabuhan_selanjutnya": "PELABUHAN SELANJUTNYA",
            "kade": "KADE",
            "tgl_tiba": "TGL TIBA",
            "jam_tiba": "JAM TIBA",
            "tgl_kedatangan": "TGL KEDATANGAN",
            "jam_kedatangan": "JAM KEDATANGAN",
            "tgl_bongkar": "TGL BONGKAR",
            "jam_bongkar": "JAM BONGKAR",
            "tgl_muat": "TGL MUAT",
            "jam_muat": "JAM MUAT",
            "tgl_keberangkatan": "TGL KEBERANGKATAN",
            "jam_keberangkatan": "JAM KEBERANGKATAN",
            "total_pos": "TOTAL POS",
            "total_kemasan": "TOTAL KEMASAN",
            "total_kontainer": "TOTAL KONTAINER",
            "total_master_bl_awb": "TOTAL MASTER BL/AWB",
            "total_bruto": "TOTAL BRUTO",
            "total_volume": "TOTAL VOLUME",
            "flag_nihil": "FLAG NIHIL",
            "status": "STATUS",
            "no_perbaikan": "NO PERBAIKAN",
            "tgl_perbaikan": "TGL PERBAIKAN",
            "seri_perbaikan": "SERI PERBAIKAN",
            "pemberitahu": "PEMBERITAHU",
            "lengkap": "LENGKAP",
            "user": "USER",
            "id_asal_data": "ID ASAL DATA",
            "id_modul": "ID MODUL",
            "waktu_rekam": "WAKTU REKAM",
            "waktu_update": "WAKTU UPDATE",
            "versi_modul": "VERSI MODUL"
        };

        function convertKeysToLabels(dataItem, map) {
            const result = {};
            for (const [key, label] of Object.entries(map)) {
                result[label] = key in dataItem ? dataItem[key] : "";
            }
            return result;
        }
        const headerSheetData = data.header.map(item => convertKeysToLabels({
            ...item,
            total_bruto: numeral(item?.total_bruto).format('0.0000'),
            // total_volume: numeral(item?.total_volume).format('0.0000'),
            total_volume: "",
            id_asal_data: "",
            id_data: "1",
            id_modul: "V180629835001",
            versi_modul: "2002",
            jns_manifest: "IA",
            kd_jns_manifest: "RK",
            status: 1,
            // pelabuhan_selanjutnya: "",
            call_sign: item?.call_sign,
            no_imo: item?.no_imo
        }, keyLabelMap));
        const wsHeader = XLSX.utils.json_to_sheet(headerSheetData);
        XLSX.utils.book_append_sheet(workbook, wsHeader, "Header");

        const headerKeysMaterEntry = headsRespon;
        const wsReponsMaterEntry = XLSX.utils.json_to_sheet([], { header: headerKeysMaterEntry });
        XLSX.utils.book_append_sheet(workbook, wsReponsMaterEntry, "Master Entry");

        const detilData = data.detil.map(item => ({
            ...item,
            fl_partial: item?.ispartial ? "Y" : "N",
            fl_konsolidasi: item?.isconsole ? "Y" : "N",
            bruto: numeral(item?.bruto).format('0.0000'),
            volume: numeral(item?.volume).format('0.0000')
        }));

        const detilSheetData = buildSheetData(detilData || [], mapDetilKeys, headsDetil);
        const wsDetil = XLSX.utils.json_to_sheet(detilSheetData);
        XLSX.utils.book_append_sheet(workbook, wsDetil, "Detil");

        const barangSheetData = buildSheetData(data.barang || [], mapBarangKeys, headsBarang);
        const wsBarang = XLSX.utils.json_to_sheet(barangSheetData);
        XLSX.utils.book_append_sheet(workbook, wsBarang, "Barang");

        if (data.dokumen && data.dokumen.length > 0) {
            const dokumenSheetData = buildSheetData(
                data.dokumen,
                mapDokumenKeys,
                headsDokumen
            );
            const wsDokumen = XLSX.utils.json_to_sheet(dokumenSheetData);
            XLSX.utils.book_append_sheet(workbook, wsDokumen, "Dokumen");
        } else {
            const dokumenSheetData = headsDokumen;
            const wsDokumen = XLSX.utils.json_to_sheet([], { header: dokumenSheetData });
            XLSX.utils.book_append_sheet(workbook, wsDokumen, "Dokumen");
        }

        const headerKeysKontainer = headsKontainer;
        const wsReponsKontainer = XLSX.utils.json_to_sheet([], { header: headerKeysKontainer });
        XLSX.utils.book_append_sheet(workbook, wsReponsKontainer, "Kontainer");

        const headerKeys = headsRespon;
        const wsRepons = XLSX.utils.json_to_sheet([], { header: headerKeys });
        XLSX.utils.book_append_sheet(workbook, wsRepons, "Respon Header");

        const excelBuffer = XLSX.write(workbook, { bookType: 'biff8', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.ms-excel' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${filename}.xls`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const sendDataLocal = async (data) => {
        const API_BASE_URL = 'http://localhost:3301/api';
        const manifestEndpoints = {
            header: `${API_BASE_URL}/manifest_hdr`,
            detail: `${API_BASE_URL}/manifest_dtl`,
            dokumen: `${API_BASE_URL}/manifest_dok`,
            kontainer: `${API_BASE_URL}/manifest_cont`,
            barang: `${API_BASE_URL}/manifest_brg`,
        };

        const parseDate = (value) => {
            if (!value) return null;
            const date = moment(value, ['DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
            return date.isValid() ? date.format('YYYY-MM-DD') : null;
        };

        const header = (data?.header ?? []).map(item => ({
            // CAR: item?.nomor_aju,
            CAR: "",
            ID_DATA: item?.id_data,
            ID_PENGANGKUT: `${item?.id_pengangkut}` || '000000000000000',
            JNS_MANIFEST: "RK",
            KD_JNS_MANIFEST: "IA",
            KD_KANTOR: item?.kppbc,
            NO_BC10: item?.no_bc_10,
            TGL_BC10: parseDate(item?.tgl_bc_10),
            NO_BC11: item?.no_bc_11,
            TGL_BC11: parseDate(item?.tgl_bc_11),
            NM_SARANA_ANGKUT: item?.nama_sarana_angkut,
            KD_MODA: item?.kode_moda,
            CALL_SIGN: item?.call_sign,
            NO_IMO: item?.no_imo,
            NO_MMSI: "",
            BENDERA: item?.negara,
            NO_VOY: item?.no_voyage_arrival,
            NO_VOY_DEPARTURE: item?.departure_flight,
            NAHKODA: item?.nahkoda,
            HANDLING_AGENT: item?.handling_agent,
            PEL_ASAL: item?.pelabuhan_asal,
            PEL_TRANSIT: item?.pelabuhan_transit,
            PEL_BONGKAR: item?.pelabuhan_bongkar,
            PEL_SELANJUTNYA: item?.pelabuhan_selanjutnya,
            KADE: item?.kade,
            TGL_TIBA: parseDate(item?.tgl_tiba),
            JAM_TIBA: item?.jam_tiba,
            TGL_KEDATANGAN: null,
            JAM_KEDATANGAN: item?.jam_kedatangan || "",
            TGL_BONGKAR: null,
            JAM_BONGKAR: item?.jam_bongkar,
            TGL_MUAT: parseDate(item?.tgl_muat),
            JAM_MUAT: item?.jam_muat,
            TGL_KEBERANGKATAN: parseDate(item?.tgl_keberangkatan),
            JAM_KEBERANGKATAN: item?.jam_keberangkatan,
            TOTAL_POS: item?.total_pos,
            TOTAL_KMS_HDR: item?.total_kemasan,
            TOTAL_CONT_HDR: item?.total_kontainer,
            TOTAL_MASTER_BLAWB: item?.total_master_bl_awb,
            TOTAL_BRUTO: item?.total_bruto,
            TOTAL_VOLUME: item?.total_volume,
            FL_NIHIL: item?.flag_nihil,
            KODE_STATUS: item?.status,
            NO_PERBAIKAN: item?.no_perbaikan,
            TGL_PERBAIKAN: parseDate(item?.tgl_perbaikan),
            SERI_PERBAIKAN: null,
            PEMBERITAHU: item?.pemberitahu,
            LENGKAP: item?.lengkap,
            USER: item?.user,
            ID_ASAL_DATA: item?.id_asal_data || "V190927216495",
            ID_MODUL: item?.id_modul,
            WK_REKAM: null,
            WK_UPDATE: null,
            FL_PERBAIKAN: null,
            KODE_STATUS_PERBAIKAN: null,
            FL_PENAMBAHAN: null,
            FL_BATAL: null,
            WK_BATAL: null,
        }));

        const detail = (data?.detil ?? []).map(item => ({
            ID_MANIFEST_DTL: item?.id_detil,
            // ID_MASTER: item?.id_master,
            ID_MASTER: null,
            CAR: item?.nomor_aju,
            KD_GROUP: item?.kd_kelompok_pos,
            NOPOS: item?.no_pos,
            SUBPOS: item?.no_sub_pos,
            SUBSUBPOS: item?.no_sub_sub_pos,
            NO_MBLAWB: item?.no_master_blawb,
            TGL_MBLAWB: parseDate(item?.tgl_master_blawb),
            NO_HBLAWB: item?.no_host_blawb,
            TGL_HBLAWB: parseDate(item?.tgl_host_blawb),
            MOTHER_VESSEL: item?.mother_vessel,
            NPWP_CONSIGNEE: item?.npwp_consignee.replace(/\D/g, ""),
            NM_CONSIGNEE: item?.nama_consignee,
            ALMT_CONSIGNEE: item?.almt_consignee,
            NEG_CONSIGNEE: item?.neg_consignee,
            NPWP_SHIPER: item?.npwp_shipper.replace(/\D/g, ""),
            NM_SHIPPER: item?.nama_shipper,
            ALMT_SHIPPER: item?.almt_shipper,
            NEG_SHIPPER: item?.neg_shipper,
            NM_NOTIFY: item?.nama_notify,
            ALMT_NOTIFY: item?.almt_notify,
            NEG_NOTIFY: item?.neg_notify || null,
            DPEL_ASAL: item?.pelabuhan_asal,
            DPEL_TRANSIT: item?.pelabuhan_transit,
            DPEL_BONGKAR: item?.pelabuhan_bongkar,
            DPEL_AKHIR: item?.pelabuhan_akhir,
            JML_KMS: item?.jumlah_kemasan,
            JNS_KMS: item?.jenis_kemasan,
            MERK_KMS: item?.merk_kemasan,
            JML_CONT: item?.jumlah_kontainer || null,
            BRUTO: item?.bruto,
            VOLUME: item?.volume,
            FL_PARTIAL: item?.ispartial ? "Y" : "N",
            TOTAL_KMS: item?.total_kemasan,
            TOTAL_CONT: item?.total_kontainer,
            STATUS_DTL: item?.status_detil,
            FL_KONSOLIDASI: item?.isconsole ? "Y" : "N",
            FL_PECAH: item?.fl_pecah,
            FL_PERBAIKAN_DTL: item?.fl_perbaikan || "N",
            WK_KIRIM: null,
            FL_PAKAI: null,
            WK_RESPON: null,
            KODE_RESPON_DTL: null,
            SERI_PERBAIKAN_DTL: null,
            FL_PENAMBAHAN: null,
            FL_BATAL: null,
            WK_BATAL: null,
        }));

        const dokumen = (data?.dokumen ?? []).map(item => ({
            ID_MANIFEST_DOK: item?.id_dokumen,
            ID_MANIFEST_DTL: item?.id_detil,
            KD_DOK: item?.kode_dokumen,
            NO_DOK: item?.nomor_dokumen,
            TGL_DOK: parseDate(item?.tanggal_dokumen),
            KPPBC_DOK: item?.kode_kantor
        }));

        const barang = (data?.barang ?? []).map(item => ({
            ID_MANIFEST_BRG: item?.id_barang,
            ID_MANIFEST_DTL: item?.id_detil,
            SERI_BRG: item?.seri_barang,
            HS_CODE: item?.hs_code,
            URAIAN_BRG: item?.uraian_barang
        }));

        const kontainer = (data?.kontainer ?? []).map(item => ({
            ID_MANIFEST_CONT: item?.id_kontainer,
            ID_MANIFEST_DTL: item?.id_detil,
            SERI_CONT: item?.seri_kontainer,
            NO_CONT: item?.nomor_kontainer,
            UK_CONT: item?.ukuran_kontainer,
            TIPE_CONT: item?.tipe_kontainer,
            JENIS_CONT: item?.jenis_kontainer,
            NO_SEGEL: item?.nomor_segel,
            STATUS_CONT: item?.status_kontainer
        }));

        const hideLoading = message.loading('Mengirim data ke server lokal...', 0);
        try {
            const requests = [
                { label: 'Header', url: manifestEndpoints.header, payload: header },
                { label: 'Detail', url: manifestEndpoints.detail, payload: detail },
                { label: 'Dokumen', url: manifestEndpoints.dokumen, payload: dokumen },
                { label: 'Kontainer', url: manifestEndpoints.kontainer, payload: kontainer },
                { label: 'Barang', url: manifestEndpoints.barang, payload: barang },
            ];

            for (const { url, payload, label } of requests) {
                if (!payload.length) {
                    continue;
                }
                await axios.post(url, payload);
                console.log(`Berhasil mengirim ${label} ke ${url}`);
            }

            message.success('Data berhasil dikirim ke server lokal');
        } catch (error) {
            console.error('Gagal mengirim data ke server lokal', error);
            message.error(error?.response?.data?.message || 'Gagal mengirim data ke server lokal');
        } finally {
            hideLoading();
        }
    }

    useEffect(() => {
        dispatch(loadCofigs());
        dispatch(loadAirlines());
        dispatch(loadAirports());
        dispatch(loadConsignee());
        dispatch(loadShipper());
        dispatch(loadNotify());
        dispatch(loadHsCode());
    }, [])

    return (
        <>
            <TablePage
                title={"RKSP"}
                url="api/v1/rskp"
                createPath="/telex/rksp/form"
                columns={columns}
            />
        </>
    )
}
